<template>
  <v-app>
    <div
      v-if="loading"
      style="position: absolute;
        top: 0px;
        left: 0px;
        height: 100%;
        width: 100%;
        z-index: 10;"
    ></div>
    <Navigation v-model="drawer" />
    <v-toolbar app dense fixed clipped-left extended :extension-height="7">
      <v-toolbar-side-icon @click.stop="toggleMenuMode"></v-toolbar-side-icon>

      <a style="height:100%;">
        <img
          :src="baseUrl + 'logo.svg'"
          :height="[!$vuetify.breakpoint.smAndDown ? '75%' : '35%']"
          @click="$router.push({name: 'main' })"
          :class="[!$vuetify.breakpoint.smAndDown ? 'mt-2' : 'mt-3']"
        />
      </a>
      <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp" class="mt-2 headline text-uppercase">
        <span>{{branding}}</span>
        <span class="font-weight-light">{{ $t('appTitle') }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="ma-0 pa-0">
        <v-menu
          v-if="isAuthenticated"
          v-model="menu"
          :close-on-content-click="false"
          lazy
          left
          offset-y
          full-width
        >
          <template slot="activator">
            <v-btn icon>
              <img
                v-if="user && user.photo && user.photo.length"
                :src="user.photo"
                :width="[!$vuetify.breakpoint.smAndDown ? '36px' : '30px']"
                :height="[!$vuetify.breakpoint.smAndDown ? '36px' : '30px']"
                style="border-radius:50%;"
              />
              <v-icon v-else>account_circle</v-icon>
            </v-btn>
          </template>
          <v-card>
            <UserTile />
          </v-card>
        </v-menu>
        <v-btn v-else icon @click="openLoginDialog">
          <v-icon>perm_identity</v-icon>
        </v-btn>
        <v-btn v-if="!isOnline" icon @click="checkSignIn({ goToMain: false });">
          <v-icon>wifi_off</v-icon>
        </v-btn>
        <v-btn icon :href="instructionUrl" target="_blank">
          <v-icon>live_help</v-icon>
        </v-btn>
      </v-toolbar-items>
      <v-progress-linear slot="extension" v-if="loading" :indeterminate="loading" ma-0></v-progress-linear>
    </v-toolbar>
    <v-content>
      <EquipmentBreadcrumbs v-if="$route.meta.needBreadcrumbs" />
      <router-view v-if="!error && signInChecked"></router-view>
    </v-content>
    <SignIn />
    <v-footer height="auto">
      <v-layout justify-center row wrap>
        <v-flex py-3 text-xs-center xs12> 
          &copy;{{ new Date().getFullYear() }}
          <strong>{{ $t('footerBranding') }}</strong>
        </v-flex>
      </v-layout>
    </v-footer>
    <template v-if="error">
      <v-snackbar :multi-line="true" :timeout="0" color="error" @input="clearError" :value="true">
        {{ error }}
        <v-btn flat dark @click.native="clearError">Close</v-btn>
      </v-snackbar>
    </template>
  </v-app>
</template>

<script>
import Navigation from './components/Navigation'
import SignIn from './views/SignInPage'
import UserTile from './components/UserTile'
import EquipmentBreadcrumbs from './components/EquipmentBreadcrumbs'

import { mapActions } from 'vuex'

import { router } from './router'

export default {
  name: 'App',
  components: {
    Navigation,
    UserTile,
    SignIn,
    EquipmentBreadcrumbs,
  },
  created() {
    if (this.$route.path.includes('eam-app')) {
      router.push({
        name: 'equipmenttypes'
      })
    }
  },
  mounted() {
    this.checkSignIn().then(() => {
      this.signInChecked = true
    })
  },
  data(vm) {
    return {
      signInChecked: false,
      menu: false,
      drawer: vm.$vuetify.breakpoint.lgAndUp
    }
  },
  methods: {
    ...mapActions([
      'userSignOut',
      'checkSignIn',
      'clearError',
      'toggleMenuMiniMode',
      'openLoginDialog'
    ]),
    toggleMenuMode() {
      if (this.$vuetify.breakpoint.lgAndUp) {
        this.$store.dispatch('toggleMenuMiniMode')
      } else {
        this.drawer = !this.drawer
      }
    }
  },
  computed: {
    appTitle() {
      return this.$store.state.base.appTitle
    },
    error() {
      return this.$store.state.base.error
    },
    loading() {
      return this.$store.state.base.loading
    },
    branding() {
      return this.$store.state.base.branding
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    user() {
      return this.$store.state.auth.user
    },
    isOnline() {
      return this.$store.getters.isOnline
    },
    baseUrl() {
      return process.env.BASE_URL
    },
    instructionUrl() {
      return require('./assets/instruction.pdf' )
    }
  }
}
</script>
